import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// ── Calcul automatique de l'âge ──────────────────────────────────────────────
// ⚠️  Remplace JJ, MM, AAAA par ta vraie date de naissance
const BIRTH_DAY   = 15;   // jour
const BIRTH_MONTH = 2;    // mois (1 = janvier)
const BIRTH_YEAR  = 2000; // année

const calculateAge = () => {
  const today = new Date();
  const birthDate = new Date(BIRTH_YEAR, BIRTH_MONTH - 1, BIRTH_DAY);
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  if (!hasHadBirthdayThisYear) age--;
  return age;
};
// ─────────────────────────────────────────────────────────────────────────────

const About = () => {
  const { t, isRTL } = useLanguage();
  const a = t.about;

  const personalInfo = [
    { label: a.birthDate,  value: a.birthDateValue },
    { label: a.age,        value: calculateAge() },   // ← age calculé dynamiquement
    { label: a.city,       value: a.cityValue },
    { label: a.email,      value: a.emailValue },
    { label: a.degree,     value: a.degreeValue },
    { label: a.phone,      value: a.phoneValue },
    { label: a.freelance,  value: a.freelanceValue },
  ];

  const techSkills = [
    {
      title: a.programDesign,
      logos: [
        { src: 'images/ImgLogoLangage/c-sharp.png',  title: 'C#',     w: 45 },
        { src: 'images/ImgLogoLangage/java.png',      title: 'Java',   w: 45 },
        { src: 'images/ImgLogoLangage/python.png',    title: 'Python', w: 45 },
        { src: 'images/ImgLogoLangage/c.png',         title: 'C',      w: 45 },
      ],
    },
    {
      title: a.webCreation,
      logos: [
        { src: 'images/ImgLogoLangage/HTML5.png',       title: 'HTML',       w: 40 },
        { src: 'images/ImgLogoLangage/CSS3.svg.png',    title: 'CSS',        w: 40 },
        { src: 'images/ImgLogoLangage/javascript.png',  title: 'JavaScript', w: 45 },
        { src: 'images/ImgLogoLangage/php.png',         title: 'PHP',        w: 60 },
      ],
      logos2: [
        { src: 'images/ImgLogoLangage/ReactJS.png', title: 'ReactJS', w: 47, rounded: true },
        { src: 'images/ImgLogoLangage/nodeJS.png',  title: 'NodeJS',  w: 45 },
        { src: 'images/ImgLogoLangage/Blazor.png',  title: 'Blazor',  w: 54 },
      ],
    },
    {
      title: a.dbLanguages,
      logos: [
        { src: 'images/ImgLogoLangage/PhpMyAdmin.png',                 title: 'phpMyAdmin', w: 90 },
        { src: 'images/ImgLogoLangage/Postgresql_elephant.svg.png',    title: 'PostgreSQL', w: 45 },
      ],
    },
    {
      title: a.cms,
      logos: [
        { src: 'images/ImgLogoLangage/WordPress.png',   title: 'WordPress',  w: 50 },
        { src: 'images/ImgLogoLangage/prestashop.svg',  title: 'Prestashop', w: 50 },
        { src: 'images/ImgLogoLangage/shopify.png',     title: 'Shopify',    w: 50 },
      ],
    },
    {
      title: a.tools,
      logos: [
        { src: 'images/ImgLogoLangage/figma.png',             title: 'Figma',        w: 29 },
        { src: 'images/ImgLogoLangage/Adobe_XD.svg.png',      title: 'Adobe XD',     w: 45 },
        { src: 'images/ImgLogoLangage/Photoshop.svg.png',     title: 'Photoshop',    w: 45 },
        { src: 'images/ImgLogoLangage/Illustrator.svg.png',   title: 'Illustrator',  w: 45 },
        { src: 'images/ImgLogoLangage/AfterEffects.svg.png',  title: 'After Effects',w: 45 },
      ],
      logos2: [
        { src: 'images/ImgLogoLangage/Visual_Studio_Code.svg.png', title: 'VS Code',      w: 45 },
        { src: 'images/ImgLogoLangage/Visual_Studio.svg.png',      title: 'Visual Studio',w: 45 },
        { src: 'images/ImgLogoLangage/azure-devops.png',            title: 'Azure DevOps', w: 45 },
        { src: 'images/ImgLogoLangage/github.svg.png',              title: 'GitHub',       w: 45 },
        { src: 'images/ImgLogoLangage/Docker.png',                  title: 'Docker',       w: 48 },
      ],
      logos3: [
        { src: 'images/ImgLogoLangage/autocad.png',     title: 'Autocad',    w: 45 },
        { src: 'images/ImgLogoLangage/Revit.png',       title: 'Revit',      w: 40 },
        { src: 'images/ImgLogoLangage/solidworks.png',  title: 'Solidworks', w: 45 },
        { src: 'images/ImgLogoLangage/Matlab.png',      title: 'Matlab',     w: 46 },
      ],
    },
  ];

  const handleContact = (e) => {
    e.preventDefault();
    const target = document.querySelector('#contact');
    if (target) window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
  };

  const LogoImg = ({ logo }) => (
    <img
      src={logo.src}
      title={logo.title}
      alt={`Logo ${logo.title}`}
      width={logo.w}
      className={`inline-block ${isRTL ? 'ml-2' : 'mr-2'} mt-2 cursor-help ${logo.rounded ? 'rounded-full' : ''}`}
    />
  );

  return (
    <section id="about" className="py-20 px-5 bg-bg-black-900">
      <div className="container mx-auto max-w-6xl">
        <div className="section-title mb-16">
          <h2 className="text-4xl font-bold relative inline-block pb-3">{a.title}</h2>
        </div>

        <div className="mb-10">
          <h3 className="text-xl font-semibold mb-4">
            {a.subtitle} <span className="text-skin-color">{a.role}</span>
          </h3>
          <p className="text-sm text-text-black-700">{a.description}</p>
        </div>

        <div className="flex flex-col md:flex-row">
          {/* Personal info */}
          <div className={`w-full md:w-3/5 ${isRTL ? 'pl-0 md:pl-8' : 'pr-0 md:pr-8'} mb-10 md:mb-0`}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {personalInfo.map((item, idx) => (
                <div key={idx}>
                  <p className="font-medium py-2 text-sm border-b border-bg-black-50">
                    {item.label} :{' '}
                    <span className={`font-normal text-text-black-700 ${isRTL ? 'mr-1' : 'ml-1'}`}>
                      {item.value}
                    </span>
                  </p>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                download="CV BENAIS Nathan"
                href="/images/pdf/CVBENAISNathan.pdf"
                className="text-sm font-medium py-3 px-8 text-white rounded-full inline-block whitespace-nowrap border-none transition-all duration-300 hover:scale-105 focus:outline-none"
                style={{ backgroundColor: 'var(--skin-color)', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)' }}
              >
                <span className="flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isRTL ? 'ml-2' : 'mr-2'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  {a.downloadCV}
                </span>
              </a>
              <a
                href="#contact"
                onClick={handleContact}
                className="text-sm font-medium py-3 px-8 text-white rounded-full inline-block whitespace-nowrap shadow-lg border-none transition-all duration-300 hover:scale-105 focus:outline-none"
                style={{ backgroundColor: 'var(--skin-color)', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.2)' }}
              >
                <span className="flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-4 ${isRTL ? 'ml-2' : 'mr-2'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  {a.contactMe}
                </span>
              </a>
            </div>
          </div>

          {/* Tech skills */}
          <div className="w-full md:w-2/5">
            {techSkills.map((group, idx) => (
              <div key={idx} className="mb-8">
                <h3 className="text-lg font-semibold mb-3">{group.title}</h3>
                <div>
                  {group.logos.map((logo, i) => <LogoImg key={i} logo={logo} />)}
                </div>
                {group.logos2 && (
                  <div className="mt-2">
                    {group.logos2.map((logo, i) => <LogoImg key={i} logo={logo} />)}
                  </div>
                )}
                {group.logos3 && (
                  <div className="mt-2">
                    {group.logos3.map((logo, i) => <LogoImg key={i} logo={logo} />)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Experience and Education */}
        <div className="flex flex-col md:flex-row mt-16">
          {/* Experiences */}
          <div className={`w-full md:w-1/2 ${isRTL ? 'md:pl-6' : 'md:pr-6'} mb-10 md:mb-0`}>
            <h3 className="text-xl font-semibold mb-8">{a.experience}</h3>
            <div className="bg-bg-black-100 p-6 rounded-lg shadow-md border border-bg-black-50">
              {a.experiences.map((exp, idx) => (
                <div key={idx} className={`relative ${isRTL ? 'pr-8' : 'pl-8'} ${idx < a.experiences.length - 1 ? 'pb-8' : 'pb-0'}`}>
                  <div className={`absolute ${isRTL ? 'right-0' : 'left-0'} top-0 h-4 w-4 rounded-full bg-skin-color`}></div>
                  <div className="timeline-item">
                    <h3 className="text-sm font-normal mb-2 text-text-black-700">
                      <i className={`fa fa-calendar ${isRTL ? 'ml-1' : 'mr-1'}`}></i> {exp.date}
                    </h3>
                    <h4 className="text-base font-bold mb-2">{exp.company}</h4>
                    <p className="text-sm text-text-black-700">{exp.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Education */}
          <div className={`w-full md:w-1/2 ${isRTL ? 'md:pr-6' : 'md:pl-6'}`}>
            <h3 className="text-xl font-semibold mb-8">{a.education}</h3>
            <div className="bg-bg-black-100 p-6 rounded-lg shadow-md border border-bg-black-50">
              {a.educations.map((edu, idx) => (
                <div key={idx} className={`relative ${isRTL ? 'pr-8' : 'pl-8'} ${idx < a.educations.length - 1 ? 'pb-8' : 'pb-0'}`}>
                  <div className={`absolute ${isRTL ? 'right-0' : 'left-0'} top-0 h-4 w-4 rounded-full bg-skin-color`}></div>
                  <div className="timeline-item">
                    <h3 className="text-sm font-normal mb-2 text-text-black-700">
                      <i className={`fa fa-calendar ${isRTL ? 'ml-1' : 'mr-1'}`}></i> {edu.date}
                    </h3>
                    <h4 className="text-base font-bold mb-2">{edu.title}</h4>
                    <p className="text-sm text-text-black-700">{edu.school}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;